export default {
  toggleTooltip: 'charts.toggleTooltip',
  toggleGrid: 'charts.toggleGrid',
  toggleOutlier: 'charts.toggleOutlier',
  toggleSmooth: 'charts.toggleSmooth',
  toggleMultiAxis: 'charts.toggleMultiAxis',
};
